import axios from "axios";
import store from "@/store";
import router from '@/router'
import errorCode from "@/utils/errorCode";
import qs from "qs";
import {Message} from "element-ui";
export function request(config) {
  // 1.创建axios的实例
  const instance = axios.create({
    timeout: 10000
  })
  //请求
  instance.interceptors.request.use(config => {
  const isToken = (config.headers || {}).isToken === false
  if (!isToken){
    const token = store.state.access_token
    config.headers['Authorization'] = 'Bearer ' + token// token
  }
    // get方法传递数组的处理（重点代码）
    if (config.method === 'get') {
      // console.log(config)
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
  return config

  }, err => {
    return err
  })

  // 2.2.响应拦截
  instance.interceptors.response.use(res => {
    const code = Number(res.data.code) || 0
    const status = Number(res.status) || 200
    const message = res.data.msg || errorCode[status] || errorCode['default']
    if (status === 424) {
      // console.log('11111')
      store.dispatch('LoginOut').then(() => {
        router.push({ path: '/login' })
      })
      return false
    }
    if (status === 426) {
      return Promise.reject(new Error(message))
    }
    if (status !== 200 || res.data.code === 1) {
      return Promise.reject(new Error(message))
    }
    return res
  }, err => {
    if(err.response.status === 424) {
      return  Promise.reject(new Message.error('用户凭证已过期，请重新登录'))
    }else {
      return Promise.reject(new Message.error(err.response.data.msg))
    }
  })
  return instance(config)
}